export default "__VITE_ASSET__B2NlvkZZ__"